import * as React from "react";
const SvgArrowRight = (props) => /* @__PURE__ */ React.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M20 12L18.6 13.4L24.2 19H12L12 21H24.2L18.6 26.6L20 28L28 20L20 12Z", fill: "#0B4566" }));
export default SvgArrowRight;
